<div class="modal--loading">
  <h1 class="modal__header">{{ title }}</h1>
  <div class="modal__loading-container">
    <spinner [color]="loadingColor" size="medium"></spinner>
  </div>
  <p *ngIf="body.length > 0" class="modal__text" [innerHtml]="body | safeHtml"></p>
</div>
